export default {
  main: '#46bbbf',
  secondary: '#000000',
  contrastingColor: '#ffffff',
  priceColor: '#46bbbf',
  entryBackground: '#46bbbf',
  menuBackgroundColor: '#46bbbf',
  menuTextColor: '#ffffff',
};
